import './BarraEscritorio.css';

// App de escritorio (1.6.1+) sin barra de titulo del sistema: el portal deja
// libre una franja arriba, la pinta con el fondo del marco (azul SURA o el de
// la campana) y sirve para mover la ventana. Los botones de Windows (o el
// semaforo en Mac) van encima, transparentes. Lo que cubre la pantalla
// (modales, visores, la llamada) empieza debajo de la franja: ver el CSS.
const barra = typeof window !== 'undefined' ? window.electronAPI?.barra : null;
export const ALTO_BARRA = barra?.altura || 0;

if (ALTO_BARRA) {
  const raiz = document.documentElement;
  raiz.classList.add('con-barra');
  raiz.style.setProperty('--alto-barra', `${ALTO_BARRA}px`);
  const franja = document.createElement('div');
  franja.className = 'barra-escritorio';
  franja.setAttribute('aria-hidden', 'true');
  document.body.appendChild(franja);
}
